import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ProjectAPIs from '../../../../../../../MasonyFixingsAPIs/ProjectAPIs/ProjectAPIs';
import { Card, Form} from 'react-bootstrap';
import DropDown from '../../../../../../DropDown/DropDown';
import { MdCancel, MdDelete, MdEdit } from 'react-icons/md';
import { FaSave } from 'react-icons/fa';
import { AiFillEdit } from 'react-icons/ai';
import {format} from 'date-fns';
import { useToast } from '../../../../../../../Contexts/ToastContext';

export default function ViewInduction({induction, getInductionData, desktop}){

    const { addToast } = useToast();
    const params = useParams();
    const navigate = useNavigate();

    const [editing, setEditing] = useState(false);
    const [sending, setSending] = useState(false);
    const [userID, setUserID] = useState(parseInt(induction.user.id));
    const [date, setDate] = useState(format(new Date(induction.date), 'yyyy-MM-dd'));



    const editInduction = () => {
        setSending(true);
        const putJSON = {
            user_id: userID,
            date: date
        }
        if(userID !== '' && date !== ''){
            ProjectAPIs.PutProjectInductionList(params.ProjectID, induction.id, putJSON)
            .then((response) => {
                if(response.status === 200){
                    getInductionData(params.ProjectID);
                    setEditing(false);
                    setSending(false);
                    addToast({ message: "Induction updated successfully!", variant: "success", autoHide: true });
                }
            })
            .catch((err) => {
                console.log(err)
                setSending(false);
                if(err.response.status === 401){
                    if(err.response.data.logout){
                        navigate('/login');
                    }
                    else{
                        setEditing(false);
                        window.alert(err.response.data.message)
                    }
                }
            })
        }
    }

    const deleteInduction = () => {
        setSending(true);
        ProjectAPIs.DeleteProjectInductionList(params.ProjectID, induction.id)
        .then((response) => {
            if(response.status === 200){
                getInductionData(params.ProjectID);
                setEditing(false);
                setSending(false);
                addToast({ message: "Induction deleted successfully!", variant: "success", autoHide: true });
            }
        })
        .catch((err) => {
            console.log(err)
            setSending(false);
            if(err.response.status === 401){
                if(err.response.data.logout){
                    navigate('/login');
                }
                else{
                    handleCancel();
                    window.alert(err.response.data.message)
                }
            }
        })
    }

    const handleCancel = () => {
        setUserID(induction.user.id);
        setDate(format(new Date(induction.date), 'yyyy-MM-dd'));
        setEditing(false);
    }

    const handleDelete = () => {
        if(window.confirm('Are you sure you wish to delete this induction entry?')){
            deleteInduction();
        }
    }

    if(desktop){
        return (
        
       
            <tr>
                <td>
                    {editing ?
                        <DropDown.Users
                            value={userID}
                            disabled={sending}
                            onChange={(e) => setUserID(e.target.value)}
                            required
                            className='editable-field'
                        /> : induction.user.first_name  + ' ' +induction.user.last_name}
                </td>
                <td>
                    {editing ?
                        <Form.Control
                            type="date"
                            value={date}
                            disabled={sending}
                            onChange={(e) => setDate(e.target.value)}
                            className="editable-field"
                        /> : induction.date}
                </td>
                <td className="project-header-actions">
                    {editing ? (
                        <>
                            <button disabled={sending} size="sm" className="save-btn" onClick={() => editInduction()}>Save</button>
                            <button disabled={sending} size="sm" className="cancel-btn" onClick={() => setEditing(false)} >Cancel</button>
                        </>
                    ) : (
                        <>
                            <button disabled={sending} className="edit-btn" onClick={() => setEditing(true)}><MdEdit /> Edit</button>
                            <button disabled={sending} className="projects-delete-btn" onClick={() => handleDelete(induction.id)} ><MdDelete /></button>
                        </>
                    )}
                </td>
            </tr>
        )
    }

        
    return(
        
        <div className="mobile-only">
            <Card key={induction.id} className="mb-2">
                <Card.Body>
                    <div>
                        
                        <div className="project-header-actions">
                            {editing ? (
                                <>
                                    <button size="sm" disabled={sending} className="save-btn" onClick={() => editInduction()}>Save</button>
                                    <button size="sm" disabled={sending} className="cancel-btn" onClick={() => setEditing(false)} >Cancel</button>
                                </>
                            ) : (
                                <>
                                    <button size="sm" disabled={sending} className="edit-btn" onClick={() => setEditing(true)}><MdEdit /> Edit</button>
                                    <button size="sm" disabled={sending} className="projects-delete-btn" onClick={() => handleDelete(induction.id)} ><MdDelete /></button>
                                </>
                            )}
                        </div>
                    </div>
                    <div>
                            {editing ? 
                            <DropDown.Users
                                    value={userID}
                                    onChange={(e) => setUserID(e.target.value)}
                                    required
                                    disabled={sending}
                                    className='editable-field m-1'
                                />
                            :
                            <strong>{induction.user.first_name  + ' ' +induction.user.last_name}</strong>}

                            {editing ? 
                            <Form.Control
                                type="date"
                                required
                                disabled={sending}
                                value={date}
                                onChange={(e) => setDate(e.target.value)}
                                className="editable-field m-1"
                            />
                            :
                        <div><strong>Date Completed:</strong> {new Date(induction.date).toLocaleDateString()}</div>
                            }
                    </div>
                </Card.Body>
            </Card>
        </div>
    )

}